
























import { computed, defineComponent } from "@vue/composition-api";
import BaseIconButton from "@/components/BaseIconButton";
import BaseSelect from "@/components/BaseSelect";
import { useSelectTimeRange } from "../../tools";
import { UserAvailabilityDisplayInterval } from "../../tools/types";
export default defineComponent({
  name: "AvailabilityRangeSettings",
  components: { BaseSelect, BaseIconButton },
  props: {
    interval: {
      type: Object as () => UserAvailabilityDisplayInterval,
      required: true,
    },
  },
  setup(props) {
    const { range12HoursOptions } = useSelectTimeRange();
    const currentValue = computed(() => ({
      startTime: `${props.interval.beginTime.hours}:${props.interval.beginTime.minutes}`,
      endTime: `${props.interval.endTime.hours}:${props.interval.endTime.minutes}`,
    }));

    return { range12HoursOptions, currentValue };
  },
});
